import styled from 'styled-components';
import { Card } from '@mui/material';

export const CardStyled = styled(Card)`
  width: ${({ width }) => (width ? width : 'auto')};
  box-shadow: 0px 2px 6px -1px rgb(0 0 0 / 20%), 0px 1px 8px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
`;
